import { render, staticRenderFns } from "./EmbedLayout.vue?vue&type=template&id=bf2a15c8&"
import script from "./EmbedLayout.vue?vue&type=script&lang=js&"
export * from "./EmbedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports